import area from './area'


function getProvincial (data) {
  area.area_list =  data
}

export default {getProvincial}

